/* src/app/front-layout/admission-open/admission-open.component.css */
.ad-logo {
  width: 150px;
  height: 50px;
}
.admission-banner {
  margin-top: 50px;
  display: flex;
  background: #fff;
  overflow: hidden;
  max-height: 50vh;
}
.admission-content {
  flex: 1;
  padding: 32px 28px 20px 28px;
  display: flex;
  flex-direction: column;
  margin: 75px;
}
.banner-header {
  margin-bottom: 22px;
}
.admission-title {
  color: #0077b6;
  font-size: 64px;
  font-weight: 700;
  margin: 0;
  line-height: 1.1;
}
.admission-subtitle {
  color: #222;
  font-size: 40px;
  font-weight: 700;
  margin: 0 0 12px 0;
  line-height: 1.1;
}
.admission-tagline {
  color: #444;
  font-size: 28px;
  margin: 0;
  font-weight: 500;
  margin-bottom: 50px;
}
.admission-programs {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.program {
  margin-bottom: 20px;
}
.program-title {
  font-size: 3rem;
  color: #222;
  font-weight: 600;
  margin: 0 0 4px 0;
}
.program-year {
  font-size: 3rem;
  color: #222;
  font-weight: 600;
  margin: 0 0 8px 0;
}
.program-desc {
  color: #555;
  font-size: 2rem;
  margin: 0 0 6px 0;
  line-height: 1.4;
}
.learn-more {
  color: #ed6823;
  font-size: 1.5rem;
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 25px;
}
.learn-more:hover {
  text-decoration: underline;
}
.apply-btn {
  background: #ed6823;
  color: white;
  text-decoration: none;
  padding: 12px 0;
  font-size: 1.5rem;
  border-radius: 50px;
  text-align: center;
  font-weight: 600;
  margin-top: 50px;
  width: 240px;
  box-shadow: 0 3px 10px rgba(237, 104, 35, 0.2);
  transition: background-color 0.2s;
}
.apply-btn:hover {
  background-color: #ca5718;
}
.admission-image {
  flex: 1;
  overflow: hidden;
  width: 55%;
}
.admission-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.course-panel {
  background: #fff;
  margin: 0 auto;
  padding: 50px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
}
.panel-header {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding: 15px 0 10px 0;
}
.header-line {
  width: 4px;
  height: 28px;
  background: #222;
  margin-right: 12px;
}
.panel-section-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #222;
  margin: 0;
}
.course-card {
  padding: 0 0 15px 0;
  width: 80%;
  align-self: center;
  background-color: rgb(246, 246, 246);
  margin-bottom: 25px;
}
.card-content {
  display: flex;
  align-items: stretch;
}
.course-info {
  flex: 1;
  padding: 25px;
  align-self: center;
}
.course-title {
  color: #0077b6;
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 2px 0;
  line-height: 1.5;
}
.plus {
  font-weight: 600;
  font-size: 48px;
}
.course-subtitle {
  font-size: 2.5rem;
  font-weight: 600;
  color: #222;
  margin: 0 0 12px 0;
}
.course-desc {
  font-size: 2rem;
  line-height: 1.4;
  margin: 0 0 16px 0;
  color: #333;
}
.scholarship-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}
.scholarship-list li {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-size: 2rem;
  color: #333;
}
.medal {
  margin-right: 8px;
  font-size: 1.1rem;
}
.apply-button {
  width: 200px;
  display: inline-block;
  background: #0077b6;
  color: white;
  text-decoration: none;
  border-radius: 50px;
  padding: 10px 22px;
  font-weight: 600;
  font-size: 1.5rem;
  text-align: center;
  transition: background 0.2s;
}
.apply-button:hover {
  background: #0077b6;
}
.course-image {
  flex: 1;
  max-width: 330px;
  height: auto;
  overflow: hidden;
}
.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.why-choose-section {
  width: 100%;
  margin: 40px auto;
  position: relative;
}
.section-banner {
  position: relative;
  height: 460px;
  overflow: hidden;
  background-image: url(/assets/images/l-w-fun.jpg);
  background-size: cover;
  background-position: center;
}
.section-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0.6) 50%,
      rgba(0, 0, 0, 0) 100%);
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.whyc-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: absolute;
  top: 30px;
  left: 30px;
}
.header-line {
  width: 4px;
  height: 28px;
  background: #fff;
  margin-right: 12px;
}
.section-title {
  color: #fff;
  font-size: 2.5rem;
  font-weight: 500;
  margin: 0;
}
.choose-content {
  margin-bottom: 20px;
}
.choose-heading {
  color: #0077b6;
  font-size: 64px;
  font-weight: 700;
  margin: 0 0 15px 0;
  line-height: 1.1;
}
.choose-heading span {
  color: #ffffff;
}
.choose-tagline {
  color: #fff;
  font-size: 2rem;
  margin: 0;
  font-weight: 400;
}
.feature-cards {
  margin: 20px;
  bottom: 40px;
  display: flex;
  justify-content: center;
  gap: 25px;
  padding: 0 20px;
}
.feature-card {
  background: #fff;
  padding: 24px 20px;
  width: 300px;
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
.card-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}
.card-icon svg {
  width: 100%;
  height: 100%;
}
.card-title {
  font-size: 2rem;
  font-weight: 600;
  color: #222;
  margin: 0 0 12px 0;
}
.card-text {
  font-size: 1.5rem;
  line-height: 1.5;
  color: #555;
  margin: 0 0 15px 0;
  flex-grow: 1;
}
.learn-more-link {
  color: #0077b6;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  display: inline-block;
  margin-top: auto;
}
.learn-more-link:hover {
  text-decoration: underline;
}
.testimonials-section {
  width: 100%;
  margin: 40px auto;
}
.testimonials-banner {
  position: relative;
  padding: 40px 0 60px 0;
  overflow: hidden;
  background-image: url(/assets/images/pt-bg.jpg);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
.testimonials-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.section-header-testimonials {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
  padding-left: 30px;
}
.header-line-testimonials {
  width: 4px;
  height: 28px;
  background: #fff;
  margin-right: 12px;
}
.section-title-testimonials {
  color: #fff;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
}
.testimonials-heading {
  margin-bottom: 40px;
  position: relative;
  z-index: 2;
  padding: 0 30px;
}
.main-heading {
  color: #fff;
  font-size: 3.2rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.1;
}
.main-heading span {
  margin-top: 10px;
  font-size: 64px;
  color: #0077b6;
}
.testimonials-container {
  display: flex;
  gap: 20px;
  padding: 0 30px;
  position: relative;
  z-index: 2;
  flex-wrap: wrap;
  justify-content: center;
}
.testimonial-card {
  background: #fff;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  width: calc(33.333% - 20px);
  display: flex;
  flex-direction: column;
  min-height: 280px;
}
.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}
.initials {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.testimonial-text {
  font-size: 1.5rem;
  line-height: 1.6;
  color: #333;
  margin: 0;
  flex-grow: 1;
}
.contact-container {
  display: flex;
  width: 100%;
  background-color: white;
  overflow: hidden;
}
.contact-info {
  flex: 1;
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.contact-heading {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1;
  letter-spacing: -0.5px;
}
.contact-heading span {
  color: #0077b6;
  font-weight: 700;
}
.contact-details {
  font-size: 16px;
  line-height: 2.2;
  margin-top: 10px;
}
.contact-line {
  margin-bottom: 5px;
  font-weight: 400;
}
.contact-image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  overflow: hidden;
}
.contact-image img {
  max-width: 70%;
  height: 70%;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 768px) {
  .admission-banner {
    margin-top: 100px;
    flex-direction: column;
    max-height: none;
  }
  .admission-content {
    margin: 30px 20px;
    padding: 0;
    order: 1;
  }
  .admission-title {
    font-size: 36px;
  }
  .admission-subtitle {
    font-size: 28px;
  }
  .admission-tagline {
    font-size: 20px;
    margin-bottom: 30px;
  }
  .program-title,
  .program-year {
    font-size: 24px;
  }
  .program-desc {
    font-size: 16px;
  }
  .admission-image {
    width: 100%;
    order: 2;
  }
  .apply-btn {
    width: 100%;
    margin-top: 30px;
  }
  .course-panel {
    padding: 30px 20px;
  }
  .course-card {
    width: 100%;
  }
  .card-content {
    flex-direction: column;
  }
  .course-title {
    font-size: 36px;
  }
  .course-subtitle {
    font-size: 24px;
  }
  .course-desc {
    font-size: 16px;
  }
  .course-image {
    max-width: 100%;
    order: -1;
  }
  .section-banner {
    height: auto;
  }
  .whyc-container {
    flex-direction: column;
  }
  .choose-heading {
    font-size: 36px;
    text-align: center;
  }
  .feature-cards {
    flex-direction: column;
    margin-top: 40px;
    align-items: center;
  }
  .feature-card {
    width: 100%;
    min-height: auto;
    margin-bottom: 30px;
  }
  .testimonials-container {
    flex-direction: column;
  }
  .testimonial-card {
    width: 100%;
    margin-bottom: 30px;
  }
  .main-heading {
    font-size: 28px;
  }
  .main-heading span {
    font-size: 36px;
  }
  .contact-container {
    flex-direction: column;
  }
  .contact-info {
    padding: 40px 20px;
    text-align: center;
  }
  .contact-heading {
    font-size: 36px;
  }
  .contact-image {
    padding: 20px;
  }
}
@media (max-width: 480px) {
  .admission-title {
    font-size: 48px;
  }
  .admission-subtitle {
    font-size: 32px;
  }
  .program-title,
  .program-year {
    font-size: 20px;
  }
  .choose-heading {
    font-size: 28px;
  }
  .main-heading span {
    font-size: 28px;
  }
  .testimonial-text {
    font-size: 14px;
  }
  .contact-details {
    font-size: 14px;
  }
}
/*# sourceMappingURL=admission-open.component.css.map */
